import {
  constructionTypesService,
  type ConstructionType,
} from '@/services/construction-types';
import { useQuery } from '@tanstack/react-query';

type UseConstructionTypesParams = {
  enabled?: boolean;
};

export function useConstructionTypes({
  enabled = true,
}: UseConstructionTypesParams = {}) {
  return useQuery<ConstructionType[], Error>({
    queryKey: ['construction-types'],
    queryFn: async () => {
      const response = await constructionTypesService.getConstructionTypes();

      if (!response.success || !response.data) {
        throw new Error(
          response.error || 'Erro ao carregar tipos de construção'
        );
      }

      return response.data.data;
    },
    enabled,
    staleTime: 5 * 60 * 1000,
  });
}
